import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import * as httpClient from "../../../util/httpClient";
import { truncate } from "fs";
import { updateState, states } from "../../../components/ReCompleteRegistration/StateManagement";
import { useHistory } from "react-router-dom";

interface IProps {
    displayData: any;
    manageState: any;
    registrationState: any;
    setRegistrationState: any;
    closePrevious: any;
    nextAuth: any;
}

const PasswordQuestions = ({ displayData, manageState, setRegistrationState, registrationState, closePrevious, nextAuth }: IProps) => {
    const { register, handleSubmit, formState, errors, watch, setValue, getValues } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    const pageURL = window.location.href;
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [doValidation, setDoValidation] = useState(true);
    const { isSubmitting } = formState;
    const getFormValues = getValues();
    if (getFormValues && doValidation) {
        const pass = getFormValues.password;
        const passConf = getFormValues.confirmNewPassword;
        let items = getFormValues.item;
        let found;
        if (items) {
            found = items && items.every((obj: any) => obj.Id && obj.Answer);
        }
        if (pass !== "" && passConf !== "" && found) {
            setBtnDisabled(false);
            setDoValidation(false);
        }
    }
    let history = useHistory();
    const isBusinessUser = displayData && displayData.isBusinessUser;
    const getInternalQuestionsSelectedMap = () => {
        let internalQuestionsSelectedMap = new Map<number, number>();
        if (
            null != registrationState &&
            null != registrationState.securityInfo &&
            registrationState.securityInfo.item &&
            registrationState.securityInfo.item.length > 0
        ) {
            registrationState.securityInfo.item.forEach((securityQuestionMetadata: any, index: number) =>
                internalQuestionsSelectedMap.set(index, securityQuestionMetadata.Id)
            );
        }

        return internalQuestionsSelectedMap;
    };
    const focusHeader = () => {       
        const head = sessionStorage.getItem("header");
        if (typeof head === "string") {
            const targetElement = document.getElementById(head);          
            if (targetElement)
                targetElement.focus();
            sessionStorage.setItem("mainContent", "label-account-type");
        }
    };
    const [state, setState] = useState({
        firstInteractionDone: false,
        securityQuestion: [],
        nextDisabled: [],
        securityQuestionAnswer: [
            { label: "Security Question 1", que: 1 },
            { label: "Security Question 2", que: 2 },
            { label: "Security Question 3", que: 3 },
        ],
        internalQuestionsSelectedMap: getInternalQuestionsSelectedMap(),
    });

    useEffect(() => {
        sessionStorage.setItem("mainContent", "password-label"); 
        const preferredLanguage = sessionStorage.getItem('preferredLanguage');
        let languageId = (preferredLanguage === 'en') ? 1 : ((preferredLanguage === 'fr') ? 2 : 1);
        let reqData = {
            registrationType: "Consumer",
            LanguageId: languageId,
        };
        if (isBusinessUser) {
            reqData.registrationType = "Business";
        }
        window.scrollTo(0, 0);
        httpClient.sendRequest("POST", "web/forgot-password/get-security-questions-by-registrationtype", reqData).then((data: any) => {
            if (data["hasError"]) {
                if (data && data.status) {
                    switch (data.status) {
                        case "INTERNAL_ERROR":
                            history.push("/register/error");
                            break;
                        default:
                            history.push("/register/error");
                            break;
                    }
                } else {
                    history.push("/register/error");
                }
            } else {
                setState({ ...state, securityQuestion: data.securityQuestionListByRegistrationType });
                disableSelectedQuestions(data.securityQuestionListByRegistrationType);
            }
        });
    }, []);

    //const setPrevious = () => {
    //  manageState(updateState(states, displayData.billingRequired, 2));
    // }

    const onSubmit = (data: any) => {
        data.item.forEach((item: any) => {
            item.Id = parseInt(item.Id);
            const selectedQuestion: any = state.securityQuestion.filter((securityQue: any) => item.Id === securityQue.id)[0];
            item.Question = selectedQuestion.value;
        });
        setRegistrationState({ ...registrationState, securityInfo: data });
        window.trackTarget("SQ-Funnel-SecureYourAccount-Step3");
        window.addToDataLayer({ event: "Submit Password and Security Questions" });
        window.addToDataLayer({
            event: "VPV",
            pageName: pageURL + " # Two Factor Authentication",
        });
        nextAuth();
    };
    const validation = {
        minLengthCharacter: (val: any) => /^.{12,}$/.test(val),
        containsCapitalLetter: (val: any) => /.*[A-Z].*/.test(val),
        containsSpecialLetter: (val: any) => /[*@!#%&()^~{}$\-_+=\[\]\|;:"'<,>\.\?]+/.test(val),
        containsSmallLetter: (val: any) => /.*[a-z].*/.test(val),
        containsNumber: (val: any) => /\d/.test(val),
    };

    const validationMessage: Record<string, string> = {
        minLengthCharacter: "Must be at least 12 characters",
        containsCapitalLetter: "Must contain at least one upper case",
        containsSmallLetter: "Must contain at least one lower case",
        containsNumber: "Must contain at least one number",
        containsSpecialLetter: "Must contain at least one special character",
    };

    const disableSelectedQuestions = (data: any) => {
        let tempSet = new Set<number>(state.internalQuestionsSelectedMap.values());
        data.forEach((question: any) => {
            question.isHidden = tempSet.has(question.id);
        });
        setState({ ...state, securityQuestion: data });
    };
    const [passwordEyeDigit, SetPasswordEyeDigit] = useState(false);
    const [confirmPasswordEyeDigit, SetConfirmPasswordEyeDigit] = useState(false);
    const disableOption = (key: number, selectedQuestionId: string) => {
        state.internalQuestionsSelectedMap.set(key, parseInt(selectedQuestionId));
        disableSelectedQuestions(state.securityQuestion);
    };
    const setMainContent = () => {
        sessionStorage.setItem("mainContent", "label-address-line-1");
    };
    return (
        <div className="box-content">
            <form id="form-que" onSubmit={handleSubmit(onSubmit)}>
                <div className="row between-sm">
                    <div className="col-xs-12 col-sm-10 col-no-gutter">
                        <p className="password-update">Update this frequently to keep your account secure</p>
                        <div className="margin-bottom-l"></div>
                        <div role="table" className="data-grid">
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label password-label">
                                        <label htmlFor="label-primary-password">Password</label>
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" >
                                        <input
                                            className="inputbox password-width"
                                            type={passwordEyeDigit ? "text" : "password"}
                                            id="label-primary-password"
                                            autoComplete="off"
                                            defaultValue={
                                                registrationState.securityInfo && Object.keys(registrationState.securityInfo).length !== 0
                                                    ? registrationState.securityInfo.password
                                                    : ""
                                            }
                                            name="password"
                                            ref={register({ validate: validation })}
                                            onBlur={(e) => setState({ ...state, firstInteractionDone: true })}
                                        />
                                        {passwordEyeDigit ? (
                                            <span className="eyePassword" onClick={() => SetPasswordEyeDigit(false)}>
                                                <em className="fa fa-eye" aria-hidden="true"></em>
                                            </span>
                                        ) : (
                                            <span className="eyePassword" onClick={() => SetPasswordEyeDigit(true)}>
                                                <em className="fa fa-eye-slash" aria-hidden="true"></em>
                                            </span>
                                        )}
                                        {Object.keys(validationMessage).map((key, value) => {
                                            let validationResultClass;

                                            if (!state.firstInteractionDone && errors && !errors.password) {
                                                validationResultClass = "validation-default password-default";
                                            }

                                            if (state.firstInteractionDone && errors && !errors.password) {
                                                validationResultClass = "validation-true password-default";
                                            }
                                            if (state.firstInteractionDone && errors && errors.password && errors.password.types) {
                                                validationResultClass = errors.password.types[key]
                                                    ? "validation-false password-false"
                                                    : "validation-true password-default";
                                            }
                                            if (!state.firstInteractionDone && errors && errors.password && errors.password.types) {
                                                validationResultClass = errors.password.types[key]
                                                    ? "validation-false password-false"
                                                    : "validation-true password-default";
                                            }
                                            return (
                                                <span className={validationResultClass}>
                                                    <p key={key}>{validationMessage[key]}</p>
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="margin-bottom-l"></div>
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label password-label">
                                        <label htmlFor="label-confirm-password">Confirm Password</label>
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value">
                                        <input
                                            type={confirmPasswordEyeDigit ? "text" : "password"}
                                            autoComplete="off"
                                            id="label-confirm-password"
                                            className={errors.confirmNewPassword ? "status-error inputbox password-width" : "inputbox password-width"}
                                            ref={register({
                                                required: true,
                                                validate: (value) => value === watch("password") || "Confirm password do not match.",
                                            })}
                                            name="confirmNewPassword"
                                            defaultValue={
                                                registrationState.securityInfo && Object.keys(registrationState.securityInfo).length !== 0
                                                    ? registrationState.securityInfo.password
                                                    : ""
                                            }
                                        />
                                        {confirmPasswordEyeDigit ? (
                                            <span className="eyePassword" onClick={() => SetConfirmPasswordEyeDigit(false)}>
                                                <em className="fa fa-eye" aria-hidden="true"></em>
                                            </span>
                                        ) : (
                                            <span className="eyePassword" onClick={() => SetConfirmPasswordEyeDigit(true)}>
                                                <em className="fa fa-eye-slash" aria-hidden="true"></em>
                                            </span>
                                        )}
                                        {errors.confirmNewPassword && errors.confirmNewPassword.type === "validate" && (
                                            <span className="form-error">
                                                <p>Passwords don't match</p>
                                            </span>
                                        )}
                                        {errors.confirmNewPassword && errors.confirmNewPassword.type === "required" && (
                                            <span className="form-error">
                                                <p>Confirm Password is required</p>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="margin-bottom-xl"></div>

                        {state.securityQuestionAnswer.length > 0 &&
                            state.securityQuestionAnswer.map((item, index) => {
                                const answerIndex = "answer" + (index + 1);
                                const queIndex = "que" + (index + 1);
                                return (
                                    <div role="table" className="data-grid" key={index}>
                                        <div role="row" className="data-row row">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label password-label" id={`label-question-${queIndex}`}>
                                                    {item.label}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="data-value" >
                                                    <select
                                                        className="inputbox password-width"
                                                        id={`label-security-${queIndex}`}
                                                        aria-labelledby={`label-question-${queIndex}`}
                                                        defaultValue={
                                                            registrationState.securityInfo && Object.keys(registrationState.securityInfo).length !== 0
                                                                ? registrationState.securityInfo.item.length > 0 &&
                                                                  registrationState.securityInfo.item[index].Id.toString()
                                                                : ""
                                                        }
                                                        name={`item[${index}].Id`}
                                                        ref={register({ required: true })}
                                                        onChange={(e) => disableOption(index, e.target.value)}
                                                        autoComplete="On"
                                                    >
                                                        <option value="">Select Security Question</option>
                                                        {state.securityQuestion.map((val: any) => (
                                                            <option
                                                                key={val.id}
                                                                value={val.id}
                                                                disabled={val.isHidden}
                                                                selected={
                                                                    val.id ==
                                                                    (registrationState.securityInfo && Object.keys(registrationState.securityInfo).length !== 0
                                                                        ? registrationState.securityInfo.item.length > 0 &&
                                                                          registrationState.securityInfo.item[index].Id.toString()
                                                                        : "")
                                                                }
                                                            >
                                                                {val.text}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {errors &&
                                                        errors["item"] &&
                                                        errors["item"][index] &&
                                                        errors["item"][index]["Id"] &&
                                                        errors["item"][index]["Id"].types &&
                                                        errors["item"][index]["Id"].types.required === true && (
                                                            <span className="form-error">
                                                                <p>Please choose one of the given security questions.</p>
                                                            </span>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                        <div role="row" className="data-row row">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label password-label" id={`label-${answerIndex}`}>
                                                    Answer <span style={{ visibility: "hidden" }}>{`label-${answerIndex}`}</span>
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="data-value" >
                                                    <input
                                                        type="text"
                                                        id={`answer-label-${answerIndex}`}
                                                        aria-labelledby={`label-${answerIndex}`}
                                                        autoComplete="On"
                                                        className={errors[answerIndex] ? "status-error inputbox password-width" : "inputbox password-width"}
                                                        name={`item[${index}].Answer`}
                                                        ref={register({
                                                            required: true,
                                                        })}
                                                        defaultValue={
                                                            registrationState.securityInfo && Object.keys(registrationState.securityInfo).length !== 0
                                                                ? registrationState.securityInfo.item.length > 0 &&
                                                                  registrationState.securityInfo.item[index].Answer
                                                                : ""
                                                        }
                                                    />
                                                    {errors["item"] &&
                                                        errors["item"][index] &&
                                                        errors["item"][index]["Answer"] &&
                                                        errors["item"][index]["Answer"].types &&
                                                        errors["item"][index]["Answer"].types.required === true && (
                                                            <span className="form-error">
                                                                <p>Answer is required.</p>
                                                            </span>
                                                        )}
                                                    {/*  {errors['item'] && errors['item'][index]['answer'] && errors['item'][index]['answer'].type && errors['item'][index]['answer'].type== "minLength" && (
                                                        <span className="form-error">
                                                            <p>
                                                                Answer must have at least four letters.
                                                         </p>
                                                        </span>
                                                    )} */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="margin-bottom-xs"></div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li className="margin-left-s">
                                <button
                                    type="button"
                                    className="btn-default
                                            btn-default btn-min-width"
                                    onClick={() => closePrevious()}
                                >
                                    <span className="btn-text" onClick={() => setMainContent ()} >Previous</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button
                                    style={{ padding: "0.25rem 0.75rem", borderRadius: "3px" }}
                                    type="submit"
                                    disabled={btnDisabled}
                                    className="btn-default btn-primary btn-min-width"
                                >
                                    <span className="btn-text" onClick={() => focusHeader()}>Continue</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default PasswordQuestions;
